import server from '@/request';

// 查询属性分类树
export const getAttributeCategoryTree = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/attributeCategory/tree', data);
};

// 新增属性分类
export const addAttributeCategory = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/attributeCategory/add', data);
};

// 更新属性分类
export const updateAttributeCategory = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/attributeCategory/update', data);
};

// 删除属性分类
export const deleteAttributeCategory = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/attributeCategory/delete', data);
};

// 启用或禁用属性分类
export const enableOrDisableAttributeCategory = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/attributeCategory/enableOrDisable', data);
};
